let rentalTabRenderer = null;
window.__selectedSeatAddon = null;
let grouped = {};

async function fetchAllMeta() {
  let a = 1,
    e = [];
  for (;;) {
    const t = await fetch(
        `/collections/baru-produk-shinkansen?view=shinkansen-meta.json&page=${a}`,
      ),
      s = await t.json();
    if (!Array.isArray(s) || 0 === s.length) break;
    if (((e = e.concat(s)), s.length < 250)) break;
    a++;
  }
  return e;
}

function setupCustomAutocomplete(a, e, t) {
  const s = document.getElementById(a),
    i = document.getElementById(e);
  function o(a = "") {
    const e = "function" == typeof t ? t() : t || [];
    renderSuggestions(s, i, e, a);
  }
  s &&
    i &&
    (s.addEventListener("input", () => o(s.value)),
    s.addEventListener("focus", () => o("")),
    s.addEventListener("click", () => o(s.value)),
    document.addEventListener("click", (a) => {
      i.contains(a.target) || a.target === s || (i.innerHTML = "");
    }));
}

const rentalProductsJson = document.getElementById("rental-products-json");
let rentalProducts = [];

const airportProducts = JSON.parse(
  document.getElementById("airport-products-json").textContent,
);

window.airportProducts = airportProducts;
let airportResultItems = [];
function parseAirportVariants() {
  ((airportResultItems = []),
    airportProducts.forEach((a) => {
      const e =
        Array.isArray(a.options) &&
        a.options.some((a) =>
          String(a || "")
            .toLowerCase()
            .includes("seat"),
        );
      Array.isArray(a.options) &&
        a.options.some((a) => {
          const e = String(a || "").toLowerCase();
          return e.includes("destination") || e.includes("tujuan");
        });
      a.variants.forEach((t) => {
        const s = t.option1 || "",
          i = t.option2 || "",
          o = t.keberangkatan_station?.trim().toLowerCase() || "",
          n = t.tujuan_station?.trim().toLowerCase() || "";
        let r = null,
          u = "";
        if ((e && (r = s), !r)) {
          const a = s.toLowerCase(),
            e = i.toLowerCase();
          a.includes("dewasa") || a.includes("anak")
            ? (u = s)
            : (e.includes("dewasa") || e.includes("anak")) && (u = i);
        }
        airportResultItems.push({
          variantId: t.id,
          productHandle: a.handle,
          productTitle: a.title,
          departureStation: o,
          destination: n,
          destinationLabel: t.tujuan_station || "",
          seater: r,
          seaterLabel: r || (u ? `Tiket ${u} Perorangan` : "Tiket Perorangan"),
          price: Number(t.price) / 100,
          image: t.foto_mobil?.startsWith("//")
            ? "https:" + t.foto_mobil
            : t.foto_mobil || "",
          description: t.deskripsi_mobil || "",
          keywords: [
            ...(o ? [o] : []),
            ...(n ? [n] : []),
            ...(r ? [r.toLowerCase()] : []),
          ],
          requires_form: !0 === a.requires_form,
          product_type: a.product_type || "unknown",
        });
      });
    }));
}

rentalProductsJson &&
  (rentalProducts = JSON.parse(rentalProductsJson.textContent));

const railPasses = [
    {
      category: "all",
      passes: [
        {
          title: "Seluruh Jepang",
          subtitle: "JR Pass Nation Wide Ordinary",
          description: "Jelajahi seluruh wilayah Jepang hanya dengan 1 Pass",
          duration: "7 / 14 / 21 Days",
          price: "2.888.000,00",
          keywords: ["Tokyo", "Sapporo", "Kanazawa", "Fuji"],
          url: "/products/jr-pass-nation-wide-ordinary",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/jr-nation-wide.png?v=1745982649",
        },
        {
          title: "Seluruh Jepang",
          subtitle: "JR Pass Nation Wide Green",
          description: "Jelajahi seluruh wilayah Jepang hanya dengan 1 Pass",
          duration: "7 / 14 / 21 Days",
          price: "4.043.000,00",
          url: "/products/jr-pass-nation-wide-green",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/jr-nation-wide.png?v=1745982649",
        },
        {
          title: "JR West Pass",
          subtitle: "Hokuriku Arch Pass 7 Days",
          description:
            "Kunci liburan murah selama 7 Days di rute Golden Route Jepang!",
          duration: "7 Days",
          price: "1.696.000,00",
          url: "/products/jr-hokuriku-arch-pass-7-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/hokuriku-west.jpg?v=1746612187",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Kansai Hiroshima Area Pass 5 Days",
          description:
            "Jelajahi Kansai dan Hiroshima dengan Bebas Sepuasnya Tanpa Batas!",
          duration: "5 Days",
          price: "1.001.000,00",
          url: "/products/jr-kansai-hiroshima-area-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kansai_hiroshima_c3c885b4-2804-412d-a4aa-8af96b0dbd24.jpg?v=1746612189",
        },
        {
          title: "JR West Pass",
          subtitle: "Kansai Area Pass",
          description:
            "Raih kebebasan menjelajah Kansai dengan Kansai Area Pass!",
          duration: "1 / 2 / 3 / 4 Days",
          price: "165.000,00",
          url: "/products/jr-kansai-area-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kansai-area-pass.jpg?v=1746612189",
        },
        {
          title: "JR West Pass",
          subtitle: "Kansai WIDE Area Pass 5 Days",
          description: "Jelajahi Kansai dengan Kansai WIDE Area Pass",
          duration: "5 Days",
          price: "707.000,00",
          url: "/products/jr-kansai-wide-area-pass-5-day",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kansai-wide.jpg?v=1746612189",
        },
        {
          title: "JR West Pass",
          subtitle: "Kansai Hokuriku Area Pass 7 Days",
          description: "Jelajahi Kansai dengan Kansai WIDE Area Pass",
          duration: "7 Days",
          price: "1.119.000,00",
          url: "/products/jr-kansai-hokuriku-area-pass-7-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kansai-hokuriku.jpg?v=1746612190",
        },
        {
          title: "JR West Pass",
          subtitle: "Hokuriku Area Pass 4 Days",
          description:
            "Jelajahi Kansai hingga Hokuriku dengan Kansai Hokuriku Area Pass",
          duration: "4 Days",
          price: "412.000,00",
          url: "/products/jr-hokuriku-area-pass-4-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/hokuriku-west.jpg?v=1746612187",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Sanyo-Sanin Northern Kyushu Pass",
          description:
            "JR Sanyo-Sanin Northern Kyushu Pass Memberikan Akses Tak Terbatas ke Shinkansen, Bus, dan Ferry di Seluruh Kyushu dan Honshu!",
          duration: "7 Days",
          price: "1.531.000,00",
          url: "/products/jr-sanyo-sanin-northen-kyushu-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/sanyo-sanin-northern-kyushu.jpg?v=1746612190",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Sanyo-Sanin Area Pass 7 Days",
          description:
            "Jelajahi Jepang tanpa batas dengan JR Sanyo Sanin Area Pass",
          duration: "7 Days",
          price: "1.354.000,00",
          url: "/products/jr-sanyo-sanin-area-pass-7-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/sanyo-sanin-area-pass.jpg?v=1746612190",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Kansai Sanin Area Pass 7 Days",
          description:
            "Jelajahi Kyoto, Osaka, dan pesisir San’in selama 7 Days tanpa batas dengan JR Kansai Sanin Area Pass",
          duration: "7 Days",
          price: "1.060.000,00",
          url: "/products/jr-sanin-okayama-area-pass-4-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kansai-sanin-area-pass.jpg?v=1746612189",
        },
        {
          title: "JR West Pass",
          subtitle: "Setouchi Area Pass 7 Days",
          description: "Nikmati petualangan 7 Days melintasi Setouchi",
          duration: "7 Days",
          price: "1.295.000,00",
          url: "/products/jr-setouchi-area-pass-7-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/setouchi-pass.jpg?v=1746612190",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Hiroshima Yamaguchi Area Pass 5 Days",
          description:
            "Jelajahi Hiroshima dan Yamaguchi selama 5 Days tanpa batas dengan JR Hiroshima Yamaguchi Area Pass",
          duration: "5 Days",
          price: "883.000,00",
          url: "/products/jr-hiroshima-yamaguchi-area-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/hiroshima-yamaguchi.jpg?v=1746612188",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Okayama Hiroshima Yamaguchi Area Pass 5 Days",
          description: "Susuri jalur bersejarah dan pesona alam Jepang barat",
          duration: "5 Days",
          price: "1.001.000,00",
          url: "/products/jr-okayama-hiroshima-yamaguchi-area-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/okayama-hiroshima-yamaguchi.jpg?v=1746612188",
        },
        {
          title: "JR West Pass",
          subtitle: "JR West All Area Pass 7 Days",
          description:
            "Rasakan kebebasan menjelajah Jepang Barat dengan JR West All Area Pass",
          duration: "7 Days",
          price: "1.369.000,00",
          url: "/products/japan-rail-west-area-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/all-area-west.jpg?v=1746612190",
        },
        {
          title: "JR East Pass",
          subtitle: "JR East Nagano-Niigata Area Pass 5 Days",
          description: "Temukan keajaiban Nagano dan Niigata tanpa batas!",
          duration: "5 Days",
          price: "1.609.000,00",
          url: "/products/jr-east-pass-nagano-niigata-area-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/nagano-niigata.png?v=1746609296",
        },
        {
          title: "JR East Pass",
          subtitle: "JR East Pass (Tohoku Area) 5 Days",
          description: "Petualangan ke Tohoku jadi lebih mudah!",
          duration: "5 Days",
          price: "1.789.000,00",
          url: "/products/jr-east-pass-tohoku-area-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/tohoku-pass.png?v=1746609296",
        },
        {
          title: "JR East Pass",
          subtitle: "Tokyo Wide Pass 3 Days | JR Pass Tokyo Wide",
          description:
            "Dari Tokyo ke Resort Ski Gala Yuzawa lebih mudah menggunakan Tokyo Wide Pass! ",
          duration: "3 Days",
          price: "989.000,00",
          url: "/products/jr-tokyo-wide-pass-3-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/tokyo-wide-pass.png?v=1746609296",
        },
        {
          title: "JR Central Pass",
          subtitle: "Takayama Hokuriku Area Tourist Pass 5 Days",
          description:
            "Nikmati perjalanan tak terbatas ke Takayama, Kanazawa, dan Shirakawa-go!",
          duration: "5 Days",
          price: "1.139.000,00",
          url: "/products/jr-takayama-hokuriku-area-tourist-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/takayama-route.jpg?v=1746609719",
        },
        {
          title: "JR Central Pass",
          subtitle: "Alpine Takayama Matsumoto Area Tourist Pass 5 Days",
          description: "Rasakan keajaiban pegunungan Jepang",
          duration: "5 Days",
          price: "1.359.000,00",
          url: "/products/japan-alpine-takayama-matsumoto-area-tourist-pass-5-Days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/alipine-takayama.jpg?v=1746609719",
        },
        {
          title: "JR Central Pass",
          subtitle: "Ise Kumano Wakayama Area Tourist Pass 5 Days",
          description:
            "Jelajahi kuil kuno, jalur ziarah magis, dan pesona pesisir Wakayama!",
          duration: "5 Days",
          price: "953.000,00",
          url: "/products/jr-ise-kumano-wakayama-area-tourist-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/ise-kumano.jpg?v=1746609719",
        },
        {
          title: "JR Central Pass",
          subtitle: "Mt. Fuji Shizuoka Area Tourist Pass Mini 3 Days",
          description: "Jelajahi keindahan Gunung Fuji dan pesona Shizuoka!",
          duration: "3 Days",
          price: "376.000,00",
          url: "/products/jr-mt-fuji-shizuoka-area-tourist-pass-mini-3-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/mt-fuji-shizuoka.jpg?v=1746609718",
        },
        {
          title: "JR Kyushu Pass",
          subtitle: "JR All Kyushu Area Pass",
          description:
            "Jelajahi seluruh seluruh keindahan Kyushu tanpa batas dengan JR All Kyushu Area Pass",
          duration: "3 / 5 / 7 Days",
          price: "1.270.000,00",
          url: "/products/jr-all-kyushu-area-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/all-kyushu.png?v=1746608244",
        },
        {
          title: "JR Kyushu Pass",
          subtitle: "JR Southern Kyushu Area Pass 3 Days",
          description: "Jelajahi keindahan Kyushu selatan tanpa batas",
          duration: "3 Days",
          price: "649.000,00",
          url: "/products/jr-southern-kyushu-area-pass-3-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/southern-kyushu.png?v=1746608242",
        },
        {
          title: "JR Kyushu Pass",
          subtitle: "JR Northern Kyushu Area Pass 3 & 5 Days",
          description: "Jelajahi keindahan Kyushu Utara",
          duration: "3 / 5 Days",
          price: "4.043.000,00",
          url: "/products/jr-northern-kyushu-area-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/northern-kyushu.png?v=1746608243",
        },
        {
          title: "JR Hokkaido Pass",
          subtitle: "JR East South Hokkaido Rail Pass 6 Days",
          description:
            "Raih Kebebasan Menjelajah Jepang Timur dan Hokkaido Tanpa Batas!",
          duration: "6 Days",
          price: "2.081.000,00",
          url: "/products/jr-east-south-hokkaido-rail-pass-6-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/east-south-hokkaido.png?v=1746610072",
        },
        {
          title: "JR Hokkaido Pass",
          subtitle: "JR Hokkaido Rail Pass 5 / 7 / 10 Days",
          description:
            "Jelajahi seluruh Hokkaido dengan bebas dan hemat menggunakan JR Hokkaido Rail Pass",
          duration: "5 / 7 / 10 Days",
          price: "1.271.000,00",
          url: "/products/jr-hokkaido-rail-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/hokkaido-rail-pass.png?v=1746610072",
        },
        {
          title: "JR Hokkaido Pass",
          subtitle: "JR Sapporo Furano Area Pass 4 Days",
          description:
            "Jelajahi Sapporo dan Furano dengan Sapporo Furano Area Pass!",
          duration: "4 Days",
          price: "648.000,00",
          url: "/products/jr-sapporo-furano-area-pass-4-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/sapporo-furano.jpg?v=1746610072",
        },
        {
          title: "JR Hokkaido Pass",
          subtitle: "JR Tohoku-South Hokkaido Rail Pass 6 Days",
          description:
            "Rasakan kebebasan menjelajahi Tohoku dan Hokkaido Selatan, petualangan tanpa batas di Jepang!",
          duration: "6 Days",
          price: "589.000,00",
          url: "/products/jr-sapporo-noborisetsu-area-pass-4-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/tohoku-south-hokkaido.png?v=1746610072",
        },
        {
          title: "JR Hokkaido Pass",
          subtitle: "Sapporo Noborisetsu Area Pass 4 Days",
          description: "Dari kota hingga onsen",
          duration: "4 Days",
          price: "578.000,00",
          url: "/products/jr-sapporo-noborisetsu-area-pass-4-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/sapporo-noboribetsu.jpg?v=1746610072",
        },
        {
          title: "JR Shikoku Pass",
          subtitle: "JR All Shikoku Area Pass",
          description: "Jelajahi seluruh sudut Shikoku tanpa batas",
          duration: "3 Days",
          price: "707.000,00",
          url: "/products/jr-all-shikoku-area-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/all-shikoku.png?v=1746607846",
        },
        {
          title: "JR Shikoku Pass",
          subtitle: "JR Kagawa Mini Rail & Ferry Pass 2 Days",
          description: "JR Kagawa Mini Rail & Ferry Pass 2 Days",
          duration: "2 Days",
          price: "354.000,00",
          url: "/products/jr-kagawa-mini-rail-ferry-pass-2-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kagawa-ferry.png?v=1746607846",
        },
      ],
    },
    {
      category: "nationwide",
      passes: [
        {
          title: "Seluruh Jepang",
          subtitle: "JR Pass Nation Wide Ordinary",
          description: "Jelajahi seluruh wilayah Jepang hanya dengan 1 Pass",
          duration: "7 / 14 / 21 Days",
          price: "2.888.000,00",
          keywords: [
            "Tokyo",
            "Yokohama",
            "Nagoya",
            "Kyoto",
            "Osaka",
            "Hiroshima",
            "Fukuoka",
            "Sendai",
            "Sapporo",
            "Aomori",
            "Akita",
            "Kanazawa",
            "Toyama",
            "Okayama",
            "Takamatsu",
            "Nagasaki",
            "Kumamoto",
            "Kagoshima",
            "Oita",
            "Miyazaki",
            "Hakodate",
            "Asahikawa",
            "Obihiro",
            "Wakkanai",
            "Abashiri",
            "Kushiro",
          ],
          url: "/products/jr-pass-nation-wide-ordinary",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/jr-nation-wide.png?v=1745982649",
        },
        {
          title: "Seluruh Jepang",
          subtitle: "JR Pass Nation Wide Green",
          description: "Jelajahi seluruh wilayah Jepang hanya dengan 1 Pass",
          duration: "7 / 14 / 21 Days",
          price: "4.043.000,00",
          keywords: [
            "Tokyo",
            "Yokohama",
            "Nagoya",
            "Kyoto",
            "Osaka",
            "Hiroshima",
            "Fukuoka",
            "Sendai",
            "Sapporo",
            "Aomori",
            "Akita",
            "Kanazawa",
            "Toyama",
            "Okayama",
            "Takamatsu",
            "Nagasaki",
            "Kumamoto",
            "Kagoshima",
            "Oita",
            "Miyazaki",
            "Hakodate",
            "Asahikawa",
            "Obihiro",
            "Wakkanai",
            "Abashiri",
            "Kushiro",
          ],
          url: "/products/jr-pass-nation-wide-green",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/jr-nation-wide.png?v=1745982649",
        },
      ],
    },
    {
      category: "west",
      passes: [
        {
          title: "JR West Pass",
          subtitle: "Hokuriku Arch Pass 7 Days",
          description:
            "Kunci liburan murah selama 7 Days di rute Golden Route Jepang!",
          duration: "7 Days",
          price: "1.696.000,00",
          keywords: [
            "Tokyo",
            "Omiya",
            "Nagano",
            "Joetsu-Myoko",
            "Toyama",
            "Kanazawa",
            "Tsuruga",
            "Fukui",
            "Obama",
            "Maibara",
            "Kyoto",
            "Osaka",
            "Shin-Osaka",
            "Kansai Airport",
          ],
          url: "/products/jr-hokuriku-arch-pass-7-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/hokuriku-west.jpg?v=1746612187",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Kansai Hiroshima Area Pass 5 Days",
          description:
            "Jelajahi Kansai dan Hiroshima dengan Bebas Sepuasnya Tanpa Batas!",
          duration: "5 Days",
          price: "1.001.000,00",
          keywords: [
            "Osaka",
            "Shin-Osaka",
            "Kyoto",
            "Kobe",
            "Nara",
            "Himeji",
            "Okayama",
            "Kurashiki",
            "Fukuyama",
            "Onomichi",
            "Hiroshima",
            "Miyajimaguchi",
            "Iwakuni",
          ],
          url: "/products/jr-kansai-hiroshima-area-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kansai_hiroshima_c3c885b4-2804-412d-a4aa-8af96b0dbd24.jpg?v=1746612189",
        },
        {
          title: "JR West Pass",
          subtitle: "Kansai Area Pass",
          description:
            "Raih kebebasan menjelajah Kansai dengan Kansai Area Pass!",
          duration: "1 / 2 / 3 / 4 Days",
          price: "165.000,00",
          keywords: [
            "Osaka",
            "Shin-Osaka",
            "Kyoto",
            "Kobe",
            "Nara",
            "Himeji",
            "Kansai Airport",
          ],
          url: "/products/jr-kansai-area-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kansai-area-pass.jpg?v=1746612189",
        },
        {
          title: "JR West Pass",
          subtitle: "Kansai WIDE Area Pass 5 Days",
          description: "Jelajahi Kansai dengan Kansai WIDE Area Pass",
          duration: "5 Days",
          price: "707.000,00",
          keywords: [
            "Osaka",
            "Shin-Osaka",
            "Kyoto",
            "Kobe",
            "Nara",
            "Himeji",
            "Okayama",
            "Kinosaki Onsen",
            "Wakayama",
            "Shirahama",
            "Tottori",
          ],
          url: "/products/jr-kansai-wide-area-pass-5-day",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kansai-wide.jpg?v=1746612189",
        },
        {
          title: "JR West Pass",
          subtitle: "Kansai Hokuriku Area Pass 7 Days",
          description: "Jelajahi Kansai dengan Kansai WIDE Area Pass",
          duration: "7 Days",
          price: "1.119.000,00",
          keywords: [
            "Osaka",
            "Kyoto",
            "Kobe",
            "Nara",
            "Himeji",
            "Kanazawa",
            "Toyama",
            "Fukui",
            "Tsuruga",
            "Obama",
            "Wakura Onsen",
          ],
          url: "/products/jr-kansai-hokuriku-area-pass-7-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kansai-hokuriku.jpg?v=1746612190",
        },
        {
          title: "JR West Pass",
          subtitle: "Hokuriku Area Pass 4 Days",
          description:
            "Jelajahi Kansai hingga Hokuriku dengan Kansai Hokuriku Area Pass",
          duration: "4 Days",
          price: "412.000,00",
          keywords: [
            "Kanazawa",
            "Toyama",
            "Fukui",
            "Tsuruga",
            "Obama",
            "Wakura Onsen",
          ],
          url: "/products/jr-hokuriku-area-pass-4-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/hokuriku-west.jpg?v=1746612187",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Sanyo-Sanin Northern Kyushu Pass",
          description:
            "JR Sanyo-Sanin Northern Kyushu Pass Memberikan Akses Tak Terbatas ke Shinkansen, Bus, dan Ferry di Seluruh Kyushu dan Honshu!",
          duration: "7 Days",
          price: "1.531.000,00",
          keywords: [
            "Osaka",
            "Kyoto",
            "Nara",
            "Kobe",
            "Bandara Kansai",
            "Okayama",
            "Hiroshima",
            "Hakata",
            "Beppu",
            "Nagasaki",
            "Tsuruga",
            "Miyajima",
            "Iwakuni",
            "Fukuoka",
            "Kitakyushu",
          ],
          url: "/products/jr-sanyo-sanin-northen-kyushu-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/sanyo-sanin-northern-kyushu.jpg?v=1746612190",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Sanyo-Sanin Area Pass 7 Days",
          description:
            "Jelajahi Jepang tanpa batas dengan JR Sanyo Sanin Area Pass",
          duration: "7 Days",
          price: "1.354.000,00",
          keywords: [
            "Osaka",
            "Shin-Osaka",
            "Kyoto",
            "Kobe",
            "Himeji",
            "Okayama",
            "Kurashiki",
            "Fukuyama",
            "Onomichi",
            "Hiroshima",
            "Yamaguchi",
            "Shimonoseki",
            "Matsue",
            "Tottori",
          ],
          url: "/products/jr-sanyo-sanin-area-pass-7-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/sanyo-sanin-area-pass.jpg?v=1746612190",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Kansai Sanin Area Pass 7 Days",
          description:
            "Jelajahi Kyoto, Osaka, dan pesisir San’in selama 7 Days tanpa batas dengan JR Kansai Sanin Area Pass",
          duration: "7 Days",
          price: "1.060.000,00",
          keywords: [
            "Osaka",
            "Shin-Osaka",
            "Kyoto",
            "Kobe",
            "Nara",
            "Himeji",
            "Tottori",
            "Matsue",
            "Izumo",
          ],
          url: "/products/jr-sanin-okayama-area-pass-4-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kansai-sanin-area-pass.jpg?v=1746612189",
        },
        {
          title: "JR West Pass",
          subtitle: "Setouchi Area Pass 7 Days",
          description: "Nikmati petualangan 7 Days melintasi Setouchi",
          duration: "7 Days",
          price: "1.295.000,00",
          keyword: [
            "Osaka",
            "Kobe",
            "Himeji",
            "Okayama",
            "Fukuyama",
            "Onomichi",
            "Hiroshima",
            "Takamatsu",
            "Matsuyama",
            "Imabari",
          ],
          url: "/products/jr-setouchi-area-pass-7-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/setouchi-pass.jpg?v=1746612190",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Hiroshima Yamaguchi Area Pass 5 Days",
          description:
            "Jelajahi Hiroshima dan Yamaguchi selama 5 Days tanpa batas dengan JR Hiroshima Yamaguchi Area Pass",
          duration: "5 Days",
          price: "883.000,00",
          keywords: [
            "Hiroshima",
            "Miyajimaguchi",
            "Iwakuni",
            "Yamaguchi",
            "Shimonoseki",
          ],
          url: "/products/jr-hiroshima-yamaguchi-area-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/hiroshima-yamaguchi.jpg?v=1746612188",
        },
        {
          title: "JR West Pass",
          subtitle: "JR Okayama Hiroshima Yamaguchi Area Pass 5 Days",
          description: "Susuri jalur bersejarah dan pesona alam Jepang barat",
          duration: "5 Days",
          price: "1.001.000,00",
          keywords: [
            "Okayama",
            "Kurashiki",
            "Hiroshima",
            "Miyajimaguchi",
            "Iwakuni",
            "Yamaguchi",
            "Shimonoseki",
          ],
          url: "/products/jr-okayama-hiroshima-yamaguchi-area-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/okayama-hiroshima-yamaguchi.jpg?v=1746612188",
        },
        {
          title: "JR West Pass",
          subtitle: "JR West All Area Pass 7 Days",
          description:
            "Rasakan kebebasan menjelajah Jepang Barat dengan JR West All Area Pass",
          duration: "7 Days",
          price: "1.369.000,00",
          keywords: [
            "Osaka",
            "Shin-Osaka",
            "Kyoto",
            "Kobe",
            "Nara",
            "Himeji",
            "Okayama",
            "Hiroshima",
            "Kanazawa",
            "Toyama",
            "Fukui",
            "Kurashiki",
            "Fukuyama",
            "Tottori",
            "Matsue",
            "Yamaguchi",
            "Fukuoka",
          ],
          url: "/products/japan-rail-west-area-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/all-area-west.jpg?v=1746612190",
        },
      ],
    },
    {
      category: "east",
      passes: [
        {
          title: "JR East Pass",
          subtitle: "JR East Nagano-Niigata Area Pass 5 Days",
          description: "Temukan keajaiban Nagano dan Niigata tanpa batas!",
          duration: "5 Days",
          price: "1.609.000,00",
          keywords: [
            "Tokyo",
            "Ueno",
            "Omiya",
            "Karuizawa",
            "Nagano",
            "Matsumoto",
            "Joetsu-Myoko",
            "Itoigawa",
            "Naoetsu",
            "Niigata",
          ],
          url: "/products/jr-east-pass-nagano-niigata-area-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/nagano-niigata.png?v=1746609296",
        },
        {
          title: "JR East Pass",
          subtitle: "JR East Pass (Tohoku Area) 5 Days",
          description: "Petualangan ke Tohoku jadi lebih mudah!",
          duration: "5 Days",
          price: "1.789.000,00",
          keywords: [
            "Tokyo",
            "Ueno",
            "Omiya",
            "Fukushima",
            "Sendai",
            "Yamagata",
            "Morioka",
            "Akita",
            "Aomori",
            "Shin-Aomori",
          ],
          url: "/products/jr-east-pass-tohoku-area-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/tohoku-pass.png?v=1746609296",
        },
        {
          title: "JR East Pass",
          subtitle: "Tokyo Wide Pass 3 Days | JR Pass Tokyo Wide",
          description:
            "Dari Tokyo ke Resort Ski Gala Yuzawa lebih mudah menggunakan Tokyo Wide Pass! ",
          duration: "3 Days",
          price: "989.000,00",
          keywords: [
            "Tokyo",
            "Shinjuku",
            "Ueno",
            "Omiya",
            "Yokohama",
            "Chiba",
            "Narita Airport",
            "Gala Yuzawa (Seasonal)",
            "Karuizawa",
            "Kofu",
            "Kawaguchiko",
            "Izu",
          ],
          url: "/products/jr-tokyo-wide-pass-3-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/tokyo-wide-pass.png?v=1746609296",
        },
      ],
    },
    {
      category: "central",
      passes: [
        {
          title: "JR Central Pass",
          subtitle: "Takayama Hokuriku Area Tourist Pass 5 Days",
          description:
            "Nikmati perjalanan tak terbatas ke Takayama, Kanazawa, dan Shirakawa-go!",
          duration: "5 Days",
          price: "1.139.000,00",
          keywords: [
            "Nagoya",
            "Gifu",
            "Mino-Ota",
            "Gero",
            "Takayama",
            "Toyama",
            "Takaoka",
            "Kanazawa",
            "Shirakawa-go (by bus)",
            "Shin-Takaoka",
          ],
          url: "/products/jr-takayama-hokuriku-area-tourist-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/takayama-route.jpg?v=1746609719",
        },
        {
          title: "JR Central Pass",
          subtitle: "Alpine Takayama Matsumoto Area Tourist Pass 5 Days",
          description: "Rasakan keajaiban pegunungan Jepang",
          duration: "5 Days",
          price: "1.359.000,00",
          keywords: [
            "Nagoya",
            "Gero",
            "Takayama",
            "Toyama",
            "Tateyama",
            "Shinano-Omachi",
            "Matsumoto",
            "Kamikochi (by bus)",
          ],
          url: "/products/japan-alpine-takayama-matsumoto-area-tourist-pass-5-Days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/alipine-takayama.jpg?v=1746609719",
        },
        {
          title: "JR Central Pass",
          subtitle: "Ise Kumano Wakayama Area Tourist Pass 5 Days",
          description:
            "Jelajahi kuil kuno, jalur ziarah magis, dan pesona pesisir Wakayama!",
          duration: "5 Days",
          price: "953.000,00",
          keywords: [
            "Nagoya",
            "Tsu",
            "Ise",
            "Toba",
            "Shingu",
            "Kii-Katsuura",
            "Nachi",
            "Wakayama",
            "Shirahama",
          ],
          url: "/products/jr-ise-kumano-wakayama-area-tourist-pass-5-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/ise-kumano.jpg?v=1746609719",
        },
        {
          title: "JR Central Pass",
          subtitle: "Mt. Fuji Shizuoka Area Tourist Pass Mini 3 Days",
          description: "Jelajahi keindahan Gunung Fuji dan pesona Shizuoka!",
          duration: "3 Days",
          price: "376.000,00",
          keywords: [
            "Fuji",
            "Gotemba",
            "Kawaguchiko",
            "AtamiIzu-Mito",
            "Shizuoka",
            "Hamamatsu",
            "Toyohashi",
          ],
          url: "/products/jr-mt-fuji-shizuoka-area-tourist-pass-mini-3-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/mt-fuji-shizuoka.jpg?v=1746609718",
        },
      ],
    },
    {
      category: "kyushu",
      passes: [
        {
          title: "JR Kyushu Pass",
          subtitle: "JR All Kyushu Area Pass",
          description:
            "Jelajahi seluruh seluruh keindahan Kyushu tanpa batas dengan JR All Kyushu Area Pass",
          duration: "3 / 5 / 7 Days",
          price: "1.270.000,00",
          keywords: [
            "Fukuoka (Hakata)",
            "Kumamoto",
            "Kagoshima",
            "Nagasaki",
            "Oita",
            "Beppu",
            "Miyazaki",
            "Hitoyoshi",
            "Aso",
          ],
          url: "/products/jr-all-kyushu-area-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/all-kyushu.png?v=1746608244",
        },
        {
          title: "JR Kyushu Pass",
          subtitle: "JR Southern Kyushu Area Pass 3 Days",
          description: "Jelajahi keindahan Kyushu selatan tanpa batas",
          duration: "3 Days",
          price: "649.000,00",
          keywords: ["Kumamoto", "Kagoshima", "Miyazaki"],
          url: "/products/jr-southern-kyushu-area-pass-3-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/southern-kyushu.png?v=1746608242",
        },
        {
          title: "JR Kyushu Pass",
          subtitle: "JR Northern Kyushu Area Pass 3 & 5 Days",
          description: "Jelajahi keindahan Kyushu Utara",
          duration: "3 / 5 Days",
          price: "4.043.000,00",
          keywords: [
            "Fukuoka",
            "Nagasaki",
            "Oita",
            "Beppu",
            "Kumamoto",
            "Kitakyushu",
            "Sasebo",
            "Huis Ten Bosch",
          ],
          url: "/products/jr-northern-kyushu-area-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/northern-kyushu.png?v=1746608243",
        },
      ],
    },
    {
      category: "hokkaido",
      passes: [
        {
          title: "JR Hokkaido Pass",
          subtitle: "JR East South Hokkaido Rail Pass 6 Days",
          description:
            "Raih Kebebasan Menjelajah Jepang Timur dan Hokkaido Tanpa Batas!",
          duration: "6 Days",
          price: "2.081.000,00",
          keywords: [
            "Tokyo",
            "Ueno",
            "Omiya",
            "Sendai",
            "Fukushima",
            "Morioka",
            "Hakodate",
            "Noboribetsu",
            "Sapporo",
          ],
          url: "/products/jr-east-south-hokkaido-rail-pass-6-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/east-south-hokkaido.png?v=1746610072",
        },
        {
          title: "JR Hokkaido Pass",
          subtitle: "JR Hokkaido Rail Pass 5 / 7 / 10 Days",
          description:
            "Jelajahi seluruh Hokkaido dengan bebas dan hemat menggunakan JR Hokkaido Rail Pass",
          duration: "5 / 7 / 10 Days",
          price: "1.271.000,00",
          keywords: [
            "Sapporo",
            "Asahikawa",
            "Hakodate",
            "Obihiro",
            "Wakkanai",
            "Abashiri",
            "Kushiro",
            "Furano",
            "Biei",
          ],
          url: "/products/jr-hokkaido-rail-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/hokkaido-rail-pass.png?v=1746610072",
        },
        {
          title: "JR Hokkaido Pass",
          subtitle: "JR Sapporo Furano Area Pass 4 Days",
          description:
            "Jelajahi Sapporo dan Furano dengan Sapporo Furano Area Pass!",
          duration: "4 Days",
          price: "648.000,00",
          keywords: ["Sapporo", "Asahikawa", "Furano", "Biei"],
          url: "/products/jr-sapporo-furano-area-pass-4-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/sapporo-furano.jpg?v=1746610072",
        },
        {
          title: "JR Hokkaido Pass",
          subtitle: "JR Tohoku-South Hokkaido Rail Pass 6 Days",
          description:
            "Rasakan kebebasan menjelajahi Tohoku dan Hokkaido Selatan, petualangan tanpa batas di Jepang!",
          duration: "6 Days",
          price: "589.000,00",
          keywords: [
            "Tokyo",
            "Ueno",
            "Sendai",
            "Morioka",
            "Aomori",
            "Hakodate",
            "Noboribetsu",
            "Sapporo",
          ],
          url: "/products/jr-sapporo-noborisetsu-area-pass-4-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/tohoku-south-hokkaido.png?v=1746610072",
        },
        {
          title: "JR Hokkaido Pass",
          subtitle: "Sapporo Noborisetsu Area Pass 4 Days",
          description: "Dari kota hingga onsen",
          duration: "4 Days",
          price: "578.000,00",
          keywords: ["Sapporo", "Noboribetsu", "Otaru"],
          url: "/products/jr-sapporo-noborisetsu-area-pass-4-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/sapporo-noboribetsu.jpg?v=1746610072",
        },
      ],
    },
    {
      category: "shikoku",
      passes: [
        {
          title: "JR Shikoku Pass",
          subtitle: "JR All Shikoku Area Pass",
          description: "Jelajahi seluruh sudut Shikoku tanpa batas",
          duration: "3 Days",
          price: "707.000,00",
          keywords: [
            "Takamatsu",
            "Tokushima",
            "Naruto",
            "Matsuyama",
            "Dogo Onsen",
            "Imabari",
            "Kochi",
            "Uwajima",
          ],
          url: "/products/jr-all-shikoku-area-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/all-shikoku.png?v=1746607846",
        },
        {
          title: "JR Shikoku Pass",
          subtitle: "JR Kagawa Mini Rail & Ferry Pass 2 Days",
          description: "JR Kagawa Mini Rail & Ferry Pass 2 Days",
          duration: "2 Days",
          price: "354.000,00",
          keywords: ["Takamatsu", "Uno", "Shodoshima", "Naoshima"],
          url: "/products/jr-kagawa-mini-rail-ferry-pass-2-days",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/kagawa-ferry.png?v=1746607846",
        },
      ],
    },
  ],

  otherPasses = [
    {
      category: "metro",
      passes: [
        {
          title: "Metro Pass",
          subtitle: "Tokyo Subway Metro Pass",
          description:
            "Mengelilingi Tokyo dengan Lebih Terjangkau Menggunakan Transportasi Alternatif Tokyo Subway!",
          duration: "24 / 48 / 72 Jam",
          keywords: ["Tokyo"],
          price: "49.000,00",
          url: "/products/tokyo-subway-ticket",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/tokyo-subway-metro-pass.webp?v=1747967881",
        },
        {
          title: "Metro Pass",
          subtitle: "Osaka Metro & Osaka City Bus Pass",
          description:
            "Nikmati perjalanan sepuasnya untuk mengelilingi Osaka sepuasnya!",
          duration: "1 / 2 Days",
          keywords: ["Osaka"],
          price: "149.000,00",
          url: "/products/osaka-metro-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/osaka-metro-pass.webp?v=1747967880",
        },
        {
          title: "Metro Pass",
          subtitle: "Fukuoka City Subway 1-Day Pass",
          description:
            "Jelajahi Fukuoka tanpa batas dengan satu kartu subway ajaib!",
          duration: "1 Days",
          keywords: ["Fukuoka"],
          price: "39.000,00",
          url: "/products/fukuoka-city-subway-1-day-pass-japan",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/fukuoka-city-subway.webp?v=1747967880",
        },
      ],
    },
    {
      category: "regional",
      passes: [
        {
          title: "Regional Pass",
          subtitle: "Osaka Amazing Pass | Tiket Subway dan Atraksi Jepang",
          description:
            "Jelajahi Osaka menggunakan kereta api dan bus, serta dapatkan akses gratis ke 40+ atraksi dengan Osaka Amazing Pass!",
          duration: "1 / 2 Days",
          keywords: ["Osaka"],
          price: "419.000,00",
          url: "/products/osaka-amazing-pass-1-hari",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/Osaka_Amazing_Pass.png?v=1747969835",
        },
        {
          title: "Regional Pass",
          subtitle: "Mt. Fuji Pass | Mt. Fuji View Express",
          description:
            "Jelajahi keindahan Gunung Fuji serta Taman Hiburan Grinpa & Fuji-Q Highland dengan satu pass!",
          duration: "1 / 2 / 3 Days",
          keywords: [
            "Kawaguschiko",
            "Fujiyoshida",
            "Fujinomiya",
            "Gotenba",
            "Mishima",
            "Shin-Fuji",
          ],
          price: "399.000,00",
          url: "/products/mt-fuji-pass-lake-kawaguchi-japan-tiket-atraksi-jepang",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/Mt._Fuji_Pass.webp?v=1747969660",
        },
        {
          title: "Regional Pass",
          subtitle: "Seibu Kawagoe Pass | Tiket Seibu Kawagoe",
          description:
            "Jelajahi pesona kota Kawagoe dengan mudah menggunakan Seibu Kawagoe Pass!",
          duration: "-",
          keywords: ["Tokyo", "Kawagoe"],
          price: "79.000,00",
          url: "/products/seibu-kawagoe-pass-tiket-seibu-kawagoe",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/Seibu_Kawagoe_Pass.png?v=1747969833",
        },
        {
          title: "Regional Pass",
          subtitle: "Seibu 1 Day Pass | Tiket 1 Days Seibu",
          description: "Dapatkah satu Days penuh petualangan di Seibu!",
          duration: "1 Days",
          keywords: [
            "Tokyo",
            "Ikebukuro",
            "Seibu Shinjuku",
            "Kawagoe",
            "Chichibu",
            "Hanno",
            "Nagatoro",
          ],
          price: "59.000,00",
          url: "/products/seibu-1-day-pass-tiket-1-hari-seibu",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/seibu_1_day_pass_1.webp?v=1747969659",
        },
        {
          title: "Regional Pass",
          subtitle: "Kintetsu Rail Pass",
          description:
            "Nikmati kebebasan bepergian ke berbagai destinasi menarik di Kansai dan sekitarnya!",
          duration: "1 / 2 / 5 Days",
          keywords: ["Osaka", "Kyoto", "Nara", "Nagoya", "Mie"],
          price: "119.000,00",
          url: "/products/kintetsu-rail-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/Kintetsu_Rail_Pass.png?v=1747969829",
        },
        {
          title: "Regional Pass",
          subtitle: "Kansai Railway Pass 2/3 Days | Kansai Thru Pass",
          description: "Bebas Jelajahi Kansai!",
          duration: "2 / 3 Days",
          keywords: ["Osaka", "Kyoto", "Nara", "Kobe", "Himeji", "Koyasan"],
          price: "329.000,00",
          url: "/products/kansai-thru-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/Kansai_Railway_Pass.webp?v=1747969660",
        },
        {
          title: "Regional Pass",
          subtitle: "Hakone Kamakura Pass 3 Days",
          description: "Temukan keajaiban Hakone dan Kamakura!",
          price: "169.000,00",
          keywords: ["Hakone", "Kamakura", "Enoshima"],
          duration: "3 Days",
          url: "/products/hakone-kamakura-3-day-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/Hakone_Kamakura_Pass.png?v=1747969834",
        },
        {
          title: "Regional Pass",
          subtitle: "Hakone Freepass 2/3 Days| Shinjuku Odawara Pass",
          description:
            "Jelajahi keindahan Hakone tanpa batas dengan Hakone Freepass",
          duration: "2 / 3 Days",
          keywords: ["Hakone"],
          price: "139.000,00",
          url: "/products/hakone-free-pass-2-days-dewasa-dewasa-2-days-hakone-pass",
          image:
            "https://cdn.shopify.com/s/files/1/0680/4094/9989/files/Hakone_Freepass.webp?v=1747969659",
        },
      ],
    },
  ],

  rentalCarList = [
    {
      category: "rental",
      passes: [
        {
          title: "Itami Airport Transfer to Osaka/Kyoto/Nara/Kobe",
          breadcrumb: "Airport Transfer",
          list1: "Up to 9 Passengers",
          list2: "Itami Airport ↔ Osaka / Kyoto / Nara / Kobe",
          keywords: ["Itami Airport", "Osaka", "Kyoto", "Nara", "Kobe"],
        },
        {
          title:
            "Sewa Mobil di Jepang | Rental Mobil Bandara Chitose ke Pusat Kota Hokkaido",
          breadcrumb: "Airport Transfer",
          list1: "Up to 9 Passengers",
          list2:
            "Chitose Airport ↔ Sapporo / Furano / Rusutsu / Niseko / Noboribetsu",
          keywords: [
            "Chitose Airport",
            "Sapporo",
            "Furano & Biei",
            "Rusutsu",
            "Niseko",
            "Noboribetsu",
          ],
        },
        {
          title:
            "Sewa Mobil di Jepang | Rental Mobil Bandara Kansai ke Osaka/Kyoto/Kobe/Nara",
          breadcrumb: "Airport Transfer",
          list1: "Up to 29 Passengers",
          list2: "Kansai Airport ↔ Osaka / Kyoto / Kobe / Nara",
          keywords: ["Kansai Airport", "Osaka", "Kyoto", "Kobe", "Nara"],
        },
        {
          title:
            "Private Kansai Airport Transfer to Osaka/Kyoto/Kobe/Nara | Private Airport Transfer One Way",
          breadcrumb: "Airport Transfer",
          list1: "Up to 29 Passengers",
          list2: "Kansai Airport ↔ Osaka / Kyoto / Kobe / Nara",
          keywords: ["Kansai Airport", "Osaka", "Kyoto", "Kobe", "Nara"],
        },
        {
          title:
            "Sewa Mobil di Jepang | Rental Mobil Bandara Itami ke Osaka/Kyoto/Nara/Kobe",
          breadcrumb: "Airport Transfer",
          list1: "Up to 29 Passengers",
          list2: "Itami Airport ↔ Osaka / Kyoto / Nara / Kobe",
          keywords: ["Itami Airport", "Osaka", "Kyoto", "Nara", "Kobe"],
        },
        {
          title: "Sewa Mobil di Jepang | Rental Mobil Tokyo Haneda Narita",
          breadcrumb: "Airport Transfer",
          list1: "Up to 18 Passengers",
          list2: "Tokyo ↔ Haneda / Narita",
          keywords: ["Tokyo", "Haneda Airport", "Narita Airport"],
        },
        {
          title:
            "Private Airport Transfer Tokyo Haneda Narita | Private Airport Transfer One Way",
          breadcrumb: "Airport Transfer",
          list1: "Up to 18 Passengers",
          list2: "Tokyo ↔ Haneda / Narita",
          keywords: ["Tokyo", "Haneda Airport", "Narita Airport"],
        },
        {
          title:
            "Private Airport Transfer To Tokyo Disney Resort | Rental Mobil Disneyland Jepang",
          breadcrumb: "Airport Transfer",
          list1: "Up to 18 Passengers",
          list2: "Disney ↔ Haneda / Narita",
          keywords: ["Disney Resort", "Haneda Airport", "Narita Airport"],
        },
        {
          title: "Sewa Mobil di Jepang | Rental Mobil Narita ke Tokyo",
          breadcrumb: "Airport Transfer",
          list1: "Up to 18 Passengers",
          list2: "Narita Airport ↔ Tokyo",
          keywords: ["Narita Airport", "Tokyo"],
        },
        {
          title:
            "Private Narita Airport Transfer to Tokyo | Private Airport Transfer One Way",
          breadcrumb: "Airport Transfer",
          list1: "Up to 18 Passengers",
          list2: "Narita Airport ↔ Tokyo",
          keywords: ["Narita Airport", "Tokyo"],
        },
        {
          title:
            "Private Airport Transfer Tokyo Haneda Narita | Private Airport Transfer One Way",
          breadcrumb: "Airport Transfer",
          list1: "Up to 18 Passengers",
          list2: "Narita Airport/Haneda Airport ↔ Tokyo ",
          keywords: ["Narita Airport", "Haneda Airport", "Tokyo"],
        },
        {
          title:
            "Private Transfer Kansai Area Osaka Kyoto Nara | Sewa Mobil di Jepang – USJ / KIX / Stasiun Shinkansen / Kyoto / Nara / Kobe",
          breadcrumb: "Point to Point",
          list1: "Up to 18 Passengers",
          list2:
            "Kansai Area (USJ / KIX / Stasiun Shinkansen Osaka / Kyoto / Nara / Kobe)",
          keywords: [
            "Osaka",
            "Kyoto",
            "Rinku",
            "Universal Studio Japan",
            "Kansai Airport",
            "Kyoto",
            "Nara",
            "Kobe",
            "Osaka Shinkansen Station",
          ],
        },
        {
          title: "Private Transfer Tokyo Area | Sewa Mobil Tokyo",
          breadcrumb: "Point to Point",
          list1: "Up to 9 Passengers",
          list2: "Tokyo Area (Tokyo to JR Station / Tokyo to Tokyo)",
          keywords: ["Tokyo", "JR Station"],
        },
        {
          title: "Private Tour Jepang – Hokkaido",
          breadcrumb: "Private Tour",
          list1: "Up to 18 Passengers",
          list2:
            "Hokkaido Area (Sapporo / Otaru / Asahikawa / Furano & Biei / Lake Toya)",
          keywords: [
            "Sapporo",
            "Otaru",
            "Asahikawa",
            "Furano & Biei",
            "Lake Toya",
          ],
        },
        {
          title: "Sewa Mobil Jepang 10 Jam Tur Hokkaido",
          breadcrumb: "Private Tour",
          list1: "Up to 18 Passengers",
          list2:
            "Hokkaido Area (Sapporo / Otaru / Asahikawa / Furano & Biei / Lake Toya)",
          keywords: [
            "Sapporo",
            "Otaru",
            "Asahikawa",
            "Furano & Biei",
            "Lake Toya",
          ],
        },
        {
          title:
            "Sewa Mobil Jepang | Rental Mobil 10 Jam Tokyo| Mt. Fuji/Hakone & Pusat Kota Tokyo",
          breadcrumb: "Private Tour",
          list1: "Up to 18 Passengers",
          list2: "Tokyo ↔ Mt. Fuji / Hakone",
          keywords: ["Tokyo", "Fuji Hakone"],
        },
        {
          title:
            "Private Tour Jepang – Tokyo | Mt. Fuji/Hakone & Downtown Tokyo",
          breadcrumb: "Private Tour",
          list1: "Up to 18 Passengers",
          list2: "Tokyo ↔ Mt. Fuji / Hakone",
          keywords: ["Tokyo", "Fuji Hakone"],
        },
        {
          title: "Private Tour Jepang – Hitachi Seaside Park",
          breadcrumb: "Private Tour",
          list1: "Up to 9 Passengers",
          list2: "Tokyo ↔ Hitachi Seaside Park",
          keywords: ["Tokyo", "Hitachi Seaside Park"],
        },
        {
          title:
            "Private Tour Jepang – Osaka/Kyoto to Amanohashidate/Ine Town/Funaya",
          breadcrumb: "Private Tour",
          list1: "Up to 18 Passengers",
          list2: "Osaka / Kyoto to Amanohashidate / Ine Town / Funaya",
          keywords: ["Osaka", "Kyoto", "Amanohashidate", "Ine Town", "Funaya"],
        },
        {
          title: "Private Tour Jepang – Tokyo To Nikko (Roundtrip)",
          breadcrumb: "Private Tour",
          list1: "Up to 18 Passengers",
          list2: "Tokyo ↔ Nikko",
          keywords: ["Tokyo", "Nikko"],
        },
        {
          title:
            "Private Day Tour – Nagoya to Shirakawa-go/Takayama/Kanazawa One-Day Tour",
          breadcrumb: "Private Tour",
          list1: "Up to 9 Passengers",
          list2: "Nagoya to Shirakawa-go / Takayama / Kanazawa",
          keywords: ["Nagoya", "Shirakawa-go", "Takayama", "Kanazawa"],
        },
        {
          title: "Sewa Mobil Jepang | Rental 10 Jam Osaka/Kyoto/Kobe/Nara",
          breadcrumb: "Private Tour",
          list1: "Up to 18 Passengers",
          list2: "Osaka / Kyoto / Kobe / Nara",
          keywords: ["Osaka", "Kyoto", "Kobe", "Nara"],
        },
        {
          title: "Private Tour Jepang – Osaka/Kyoto/Kobe/Nara",
          breadcrumb: "Private Tour",
          list1: "Up to 18 Passengers",
          list2: "Osaka / Kyoto / Kobe / Nara",
          keywords: ["Osaka", "Kyoto", "Kobe", "Nara"],
        },
        {
          title:
            "Private Transfer Hotels Tokyo To Disney | Rental Mobil Disneyland Jepang",
          breadcrumb: "Point to Point",
          list1: "Up to 9 Passengers",
          list2: "Hotel ↔ Disney Resort",
          keywords: ["Hotel", "Disney Resort"],
        },
        {
          title:
            "Private Airport Transfer To Tokyo Disney Resort | Rental Mobil Disneyland Jepang",
          breadcrumb: "Airport Transfer",
          list1: "Up to 18 Passengers",
          list2: "Narita Airport / Haneda Airport ↔ Disneyland",
          keywords: ["Narita Airport", "Haneda Airport", "Disneland"],
        },
      ],
    },
  ],

  guideContentMap = {
    nationwide: {
      title: "Nationwide",
      desc: "Tiket kereta khusus untuk wisatawan asing yang memberikan akses tanpa batas ke hampir seluruh jaringan \n            kereta Japan Railways (JR) di Jepang, termasuk Shinkansen (kecuali Nozomi dan Mizuho). Tersedia dalam \n            pilihan durasi 7, 14, dan 21 Days, pass ini memungkinkan perjalanan hemat dan praktis ke berbagai kota \n            besar dan destinasi populer di seluruh negeri. ",
    },
    west: {
      title: "JR West Pass",
      desc: "JR West melayani wilayah Kansai, Chugoku, dan sebagian wilayah Hokuriku. Operator ini bertanggung \n           jawab atas Sanyo Shinkansen (Osaka–Hakata) dan berbagai jalur lokal di Osaka, Kyoto, Hiroshima, \n           serta kereta ekspres populer seperti Thunderbird, Haruka (ke Bandara Kansai), dan Kuroshio (ke Wakayama\n           /Shirahama).",
    },
    east: {
      title: "JR East Pass",
      desc: "JR East mencakup wilayah Tohoku, Kanto, dan bagian utara Chubu, termasuk kota besar seperti \n           Tokyo, Sendai, dan Niigata. Operator ini mengelola sejumlah Shinkansen utama, seperti Tohoku \n           Shinkansen, Joetsu Shinkansen, dan Hokuriku Shinkansen (hingga Kanazawa). Jalur dalam kota \n           seperti Yamanote Line juga termasuk dalam jaringan JR East.",
    },
    central: {
      title: "JR Central Pass",
      desc: "Berbasis di Nagoya, JR Central mengelola Tokaido Shinkansen yang menghubungkan Tokyo, Nagoya, \n           Kyoto, dan Osaka; jalur Shinkansen tersibuk di Jepang. Selain itu, JR Central mengoperasikan \n           jalur lokal dan ekspres seperti Limited Express Hida (Nagoya–Takayama–Toyama) dan Shirasagi \n           (Nagoya–Kanazawa).",
    },
    kyushu: {
      title: "JR Kyushu Pass",
      desc: "JR Kyushu mencakup seluruh wilayah Pulau Kyushu, termasuk kota besar seperti Fukuoka (Hakata), \n           Kumamoto, dan Kagoshima. Operator ini mengelola Kyushu Shinkansen (Hakata–Kagoshima-Chuo) serta \n           kereta ekspres seperti Yufuin no Mori, Sonic, dan kereta mewah Seven Stars in Kyushu.",
    },
    hokkaido: {
      title: "JR Hokkaido Pass",
      desc: "JR Hokkaido mengoperasikan seluruh jalur kereta di pulau Hokkaido, termasuk rute utama yang \n           paling banyak digunakan seperti Sapporo–Asahikawa, Hakodate–Sapporo, dan Sapporo–Wakkanai. \n           Operator ini juga melayani bagian utara dari Hokkaido Shinkansen hingga Shin-Hakodate-Hokuto, \n           serta jalur pemandangan alam seperti ke Abashiri dan Kushiro.",
    },
    shikoku: {
      title: "JR Shikoku Pass",
      desc: "JR Shikoku mengoperasikan seluruh jaringan kereta di Pulau Shikoku, mencakup kota-kota seperti Takamatsu, \n          Matsuyama, dan Kochi. Meskipun tidak memiliki Shinkansen, JR Shikoku terkenal dengan kereta ekspres seperti Nanpu, \n          Shiokaze, dan kereta wisata Iyonada Monogatari yang melintasi rute pesisir.",
    },
  };

let stationRoutes = {};
window.shinkansenProducts &&
  Array.isArray(window.shinkansenProducts) &&
  window.shinkansenProducts.forEach((a) => {
    const e = a.metafields?.departure_station?.trim();
    let t = a.metafields?.arrival_station;
    if (e && t) {
      if ("string" == typeof t && t.startsWith("["))
        try {
          t = JSON.parse(t);
        } catch (a) {
          t = [t];
        }
      else "string" == typeof t && (t = t.split(",").map((a) => a.trim()));
      (Array.isArray(t) || (t = [t]),
        stationRoutes[e] || (stationRoutes[e] = []),
        t.forEach((a) => {
          a && !stationRoutes[e].includes(a) && stationRoutes[e].push(a);
        }));
    }
  });

const carRentalRoutes = {
    Tokyo: [
      "Narita Airport",
      "Haneda Airport",
      "Tokyo",
      "Fuji Hakone",
      "Nikko",
      "JR Station",
    ],
    "Fuji Hakone": ["Tokyo"],
    "JR Station": ["Tokyo"],
    Nikko: ["Tokyo"],
    "Kansai Airport": ["Osaka", "Kyoto", "Kobe", "Nara"],
    Osaka: [
      "Osaka",
      "Kyoto",
      "Kobe",
      "Nara",
      "Itami Airport",
      "Kansai Airport",
      "Universal Studio Japan",
      "Osaka Shinkansen Station",
      "Amanohashidate",
      "Ine Town",
      "Funaya",
      "Rinku",
    ],
    "Osaka Shinkansen Station": ["Osaka", "Universal Studio Japan"],
    Kyoto: [
      "Amanohashidate",
      "Ine Town",
      "Funaya",
      "Kyoto",
      "Kansai Airport",
      "Itami Airport",
      "Rinku",
      "Osaka",
    ],
    Amanohashidate: ["Kyoto", "Osaka"],
    Funaya: ["Kyoto", "Osaka"],
    "Ine Town": ["Kyoto", "Osaka"],
    "Universal Studio Japan": ["Osaka Shinkansen Station", "Osaka"],
    Nara: ["Rinku", "Itami Airport", "Kansai Airport", "Osaka"],
    Rinku: ["Osaka", "Kyoto", "Nara"],
    "Itami Airport": ["Osaka", "Kyoto", "Kobe", "Nara"],
    Kobe: ["Itami Airport", "Kansai Airport", "Osaka"],
    "Disney Resort": ["Hotel", "Narita Airport", "Haneda Airport"],
    "Narita Airport": ["Disney Resort", "Tokyo"],
    "Haneda Airport": ["Disney Resort", "Tokyo"],
    Hotel: ["Disney Resort"],
    Sapporo: ["Sapporo", "Chitose Airport"],
    "Furano & Biei": ["Furano & Biei", "Chitose Airport"],
    "Chitose Airport": ["Furano & Biei", "Sapporo"],
    Otaru: ["Otaru"],
    Asahikawa: ["Asahikawa"],
    "Lake Toya": ["Lake Toya"],
    "Hitachi Seaside Park": ["Tokyo"],
    Nagoya: ["Nagoya", "Takayama", "Shirakawa-Go", "Kanazawa"],
    Takayama: ["Nagoya"],
    "Shirakawa-Go": ["Nagoya"],
    Kanazawa: ["Nagoya"],
  },

  keywordGroups = [
    {
      category: "popular",
      label: "Destinasi Terpopuler",
      keywords: [
        "Tokyo",
        "Osaka",
        "Kyoto",
        "Sapporo",
        "Hiroshima",
        "Kansai Airport",
        "Nara",
        "Nagasaki",
        "Hakodate",
      ],
    },
    {
      category: "west",
      label: "West Pass",
      keywords: [
        "Osaka",
        "Kyoto",
        "Shin-Osaka",
        "Kansai Airport",
        "Kobe",
        "Nara",
        "Himeji",
        "Okayama",
        "Kurashiki",
        "Fukuyama",
        "Onomichi",
        "Hiroshima",
        "Miyajimaguchi",
        "Iwakuni",
        "Kinosaki Onsen",
        "Wakayama",
        "Shirahama",
        "Tottori",
        "Wakura Onsen",
        "Bandara Kansai",
        "Matsue",
        "Izumo",
      ],
    },
    {
      category: "east",
      label: "East Pass",
      keywords: [
        "Tokyo",
        "Ueno",
        "Omiya",
        "Karuizawa",
        "Nagano",
        "Matsumoto",
        "Joetsu-Myoko",
        "Itoigawa",
        "Naoetsu",
        "Niigata",
        "Fukushima",
        "Sendai",
        "Yamagata",
        "Morioka",
        "Akita",
        "Aomori",
        "Shin-Aomori",
        "Shinjuku",
        "Yokohama",
        "Chiba",
        "Narita Airport",
        "Gala Yuzawa",
        "Kofu",
        "Kawaguchiko",
        "Izu",
      ],
    },
    {
      category: "central",
      label: "Central Pass",
      keywords: [
        "Nagoya",
        "Gifu",
        "Mino-Ota",
        "Gero",
        "Takayama",
        "Toyama",
        "Takaoka",
        "Kanazawa",
        "Shirakawa-go",
        "Shin-Takaoka",
        "Tateyama",
        "Shinano-Omachi",
        "Matsumoto",
        "Kamikochi",
        "Tsu",
        "Ise",
        "Toba",
        "Shingu",
        "Kii-Katsuura",
        "Nachi",
        "Fuji",
        "Gotemba",
        "Kawaguchiko",
        "Atami",
        "Izu-Mito",
        "Shizuoka",
        "Hamamatsu",
        "Toyohashi",
      ],
    },
    {
      category: "kyushu",
      label: "Kyushu Pass",
      keywords: [
        "Fukuoka",
        "Hakata",
        "Kumamoto",
        "Kagoshima",
        "Nagasaki",
        "Oita",
        "Beppu",
        "Miyazaki",
        "Hitoyoshi",
        "Aso",
        "Kitakyushu",
        "Sasebo",
        "Huis Ten Bosch",
      ],
    },
    {
      category: "hokkaido",
      label: "Hokkaido Pass",
      keywords: [
        "Tokyo",
        "Ueno",
        "Omiya",
        "Sendai",
        "Fukushima",
        "Morioka",
        "Hakodate",
        "Noboribetsu",
        "Sapporo",
        "Asahikawa",
        "Obihiro",
        "Wakkanai",
        "Abashiri",
        "Kushiro",
        "Furano",
        "Biei",
        "Aomori",
        "Otaru",
      ],
    },
    {
      category: "shikoku",
      label: "Shikoku Pass",
      keywords: [
        "Takamatsu",
        "Tokushima",
        "Naruto",
        "Matsuyama",
        "Dogo Onsen",
        "Imabari",
        "Kochi",
        "Uwajima",
        "Uno",
        "Shodoshima",
        "Naoshima",
      ],
    },
    {
      category: "regional",
      label: "Regional Pass",
      keywords: [
        "Koyasan",
        "Hakone",
        "Fujiyoshida",
        "Fujinomiya",
        "Gotenba",
        "Mishima",
        "Shin-Fuji",
        "Enoshima",
        "Kamakura",
      ],
    },
  ],

  airportRoutes = {
    "Narita Airport": ["Tokyo"],
    Tokyo: ["Narita Airport", "Haneda Airport"],
    "Kansai Airport": ["Osaka", "Kyoto", "Kobe", "Nara", "Namba Station"],
    Osaka: ["Kansai Airport", "Kobe Airport"],
    Kyoto: ["Kansai Airport", "Kobe Airport"],
    Kobe: ["Kansai Airport"],
    Nara: ["Kansai Airport"],
    "Haneda Airport": ["Tokyo"],
    "Chitose Airport": [
      "Sapporo",
      "Furano",
      "Rusutsu",
      "Niseko",
      "Noboribetsu",
    ],
    Sapporo: ["Chitose Airport"],
    Furano: ["Chitose Airport"],
    Rusutsu: ["Chitose Airport"],
    Niseko: ["Chitose Airport"],
    Noboribetsu: ["Chitose Airport"],
    "Nagoya Airport": ["Nagoya", "Takayama", "Kanazawa", "Hirayu"],
    Nagoya: ["Nagoya Airport"],
    Takayama: ["Nagoya Airport"],
    Kanazawa: ["Nagoya Airport"],
    Hirayu: ["Nagoya Airport"],
    "Kobe Airport": ["Osaka", "Kyoto"],
    "Namba Station": ["Kansai Airport"],
  };

let selectedAirportDirection = "airportToCity",
  selectedAirportFrom = "";
document.querySelectorAll('input[name="airport-direction"]').forEach((a) => {
  a.addEventListener("change", function () {
    ((selectedAirportDirection = this.value),
      (selectedAirportFrom = ""),
      (document.getElementById("AirportFromInput").value = ""),
      (document.getElementById("AirportToInput").value = ""));
    const a = document.getElementById("airportFromList"),
      e = document.getElementById("airportToList");
    (a && (a.innerHTML = ""), e && (e.innerHTML = ""));
  });
});

(function initAirportAutocompletes() {
  const fromInput = document.getElementById("AirportFromInput");
  const toInput = document.getElementById("AirportToInput");
  const fromList = document.getElementById("airportFromList");
  const toList = document.getElementById("airportToList");
  if (!fromInput || !toInput || !fromList || !toList) return;

  setupCustomAutocomplete("AirportFromInput", "airportFromList", () =>
    selectedAirportDirection === "airportToCity"
      ? Object.keys(airportRoutes).filter((k) => {
          const x = k.toLowerCase();
          return x.includes("airport") || x.includes("station");
        })
      : Object.keys(airportRoutes).filter(
          (k) => !k.toLowerCase().includes("airport"),
        ),
  );

  setupCustomAutocomplete("AirportToInput", "airportToList", () => {
    const from = fromInput.value.trim();
    return from && airportRoutes[from] ? airportRoutes[from] : [];
  });

  fromInput.addEventListener("input", function () {
    const typed = (this.value || "").trim();
    const match = Object.keys(airportRoutes).find(
      (k) => k.toLowerCase() === typed.toLowerCase(),
    );
    toInput.disabled = false;
    if (!match) toList.innerHTML = "";
  });

  toInput.addEventListener("input", function () {
    handleAirportSearch();
  });
})();

const reverseRoutes = {};

Object.entries(stationRoutes).forEach(([a, e]) => {
  e.forEach((e) => {
    (reverseRoutes[e] || (reverseRoutes[e] = []),
      reverseRoutes[e].includes(a) || reverseRoutes[e].push(a));
  });
});

const stationOptions = Object.keys(stationRoutes)
  .concat(...Object.values(stationRoutes))
  .filter((a, e, t) => t.indexOf(a) === e);

function renderSuggestions(a, e, t) {
  const s = a.value.toLowerCase();
  t.innerHTML = "";
  e.filter((a) => a.toLowerCase().includes(s)).forEach((e) => {
    const s = document.createElement("div");
    ((s.className = "autocomplete-item"),
      (s.textContent = e),
      s.addEventListener("click", () => {
        ((a.value = e), (t.innerHTML = ""));
      }),
      t.appendChild(s));
  });
}

function setupCustomAutocomplete(a, e, t) {
  const s = document.getElementById(a),
    i = document.getElementById(e);
  s &&
    i &&
    (s.addEventListener("focus", () => {
      const a = "function" == typeof t ? t() : t;
      renderSuggestions(s, a, i);
    }),
    s.addEventListener("input", () => {
      const a = "function" == typeof t ? t() : t;
      renderSuggestions(s, a, i);
    }));
}

function setupLinkedAutocomplete(a, e, t) {
  const s = document.getElementById(a),
    i = document.getElementById(e),
    o = document.getElementById(a + "List"),
    n = document.getElementById(e + "List");
  function r() {
    const a = Object.keys(t);
    renderSuggestions(s, a, o);
  }
  function u() {
    const a = s.value.trim();
    if (!a || !t[a]) return void (n.innerHTML = "");
    const e = t[a];
    renderSuggestions(i, e, n);
  }
  s &&
    i &&
    o &&
    n &&
    (s.addEventListener("focus", r),
    s.addEventListener("input", r),
    s.addEventListener("change", () => {
      ((i.value = ""), (n.innerHTML = ""));
    }),
    i.addEventListener("focus", u),
    i.addEventListener("input", u));
}

function updateToOptions(a) {
  const e = document.getElementById("toStationInput"),
    t = document.getElementById("toStationList"),
    s = stationRoutes[a] || reverseRoutes[a] || [];
  ((t.innerHTML = s.map((a) => `<li>${a}</li>`).join("")),
    t.querySelectorAll("li").forEach((a) => {
      a.addEventListener("click", () => {
        ((e.value = a.textContent), (t.style.display = "none"));
      });
    }));
}

function renderedFilteredResult(a, e, t = "") {
  const s = document.getElementById("tab-extra-content");
  if (!s) return;
  const i = e === railPasses ? DEFAULT_IMAGE_JR : DEFAULT_IMAGE_OTHER;
  let o;
  if (t) o = a;
  else {
    if (
      ((o = a.filter((a) => {
        const e = document.createElement("div");
        return ((e.innerHTML = a), !0);
      })),
      0 === o.length)
    )
      return void (s.innerHTML =
        '\n        <div class="railpass-vertical-container">\n          <div class="railpass-content-area">\n              <div class="main-content">\n                <p>Tidak ada hasil pencarian untuk kategori ini</p>\n              </div>\n          </div>\n        </div>');
    s.innerHTML = `\n      <div class="railpass-vertical-container">\n        <div class="railpass-content-area">\n            <div class="main-content">\n              ${o.join("")}\n            </div>\n            <div class="Sidebar-content">\n              <div class="sidebar-image">\n                <img src="${i}" alt="Gambar Sidebar Default" class="img-fluid rounded mb-2">\n              </div>\n            </div>\n        </div>\n      </div>`;
  }
  const n = s.querySelectorAll(".railpass-nav li");
  n.forEach((a) => {
    a.addEventListener("click", function () {
      const a = this.getAttribute("data-type"),
        e = document
          .querySelector('#tab-otherpass input[name="q"]')
          .value.trim()
          .toLowerCase();
      if (
        (n.forEach((a) => a.classList.remove("active")),
        this.classList.add("active"),
        e)
      ) {
        renderedFilteredResult(
          filteredRailPasses(e, a, otherPasses),
          otherPasses,
        );
      } else renderRailpassExtraContent(a, otherPasses);
    });
  });
}

function handleShinkansenSearch(a) {
  a && a.preventDefault();

  const from = (
    document.querySelector("#fromStationInput")?.value || ""
  ).trim();
  const to = (document.querySelector("#toStationInput")?.value || "").trim();

  if (!from || !to) {
    window.location.assign("/pages/explore-japantrips?type=shinkansen");
    return;
  }

  const url = `/pages/explore-japantrips?${new URLSearchParams({
    type: "shinkansen",
    from,
    to,
  }).toString()}`;

  window.location.assign(url);
}

function handleShinkansenReset() {
  const a = document.getElementById("fromStationInput"),
    e = document.getElementById("toStationInput");
  document.getElementById("tab-extra-content");
  ((a.value = ""), (e.value = ""));
}

function setupRentalAutocomplete() {
  (setupCustomAutocomplete("rentalFromInput", "rentalFromList", () =>
    Object.keys(carRentalRoutes),
  ),
    setupCustomAutocomplete("rentalToInput", "rentalToList", () => {
      const a = document.getElementById("rentalFromInput").value;
      return carRentalRoutes[a] || reverseRoutes[a] || [];
    }));
}

function handleRentalSearch(a) {
  a && a.preventDefault();

  const pickup = (
    document.getElementById("rentalFromInput")?.value || ""
  ).trim();
  const dropoff = (
    document.getElementById("rentalToInput")?.value || ""
  ).trim();

  if (!pickup || !dropoff) {
    window.location.assign("/pages/explore-japantrips?type=rental");
    return;
  }

  const url = `/pages/explore-japantrips?${new URLSearchParams({
    type: "rental",
    pickup,
    dropoff,
  }).toString()}`;

  window.location.assign(url);
}

function handleRentalReset() {
  ((document.getElementById("rentalFromInput").value = ""),
    (document.getElementById("rentalToInput").value = ""));
  const a = document.getElementById("tab-extra-content");
  "function" == typeof rentalTabRenderer && (a.innerHTML = rentalTabRenderer());
}

function handleAirportSearch(a) {
  a && a.preventDefault();

  const from = (
    document.getElementById("AirportFromInput")?.value || ""
  ).trim();
  const to = (document.getElementById("AirportToInput")?.value || "").trim();

  if (!from || !to) {
    window.location.assign("/pages/explore-japantrips?type=airport");
    return;
  }

  const url = `/pages/explore-japantrips?${new URLSearchParams({
    type: "airport",
    from,
    to,
  }).toString()}`;

  window.location.assign(url);
}

function handleAirportReset() {
  ((document.getElementById("AirportFromInput").value = ""),
    (document.getElementById("AirportToInput").value = ""));
  document.getElementById("tab-extra-content");
}

(document
  .getElementById("reset-shinkansen")
  ?.addEventListener("click", handleShinkansenReset),
  document
    .querySelector("#tab-shinkansen .search-btn2")
    ?.addEventListener("click", handleShinkansenSearch),
  document
    .querySelectorAll('#tab-shinkansen input[type="text"]')
    .forEach((a) => {
      a.addEventListener("keypress", (a) => {
        "Enter" === a.key && handleShinkansenSearch(a);
      });
    }),

  document.querySelector(".rental-arrow")?.addEventListener("click", () => {
    const a = document.getElementById("rentalFromInput"),
      e = document.getElementById("rentalToInput");
    [a.value, e.value] = [e.value, a.value];
  }),

  document.querySelectorAll('#tab-rental input[type="text"]').forEach((a) => {
    a.addEventListener("keypress", (a) => {
      "Enter" === a.key && handleRentalSearch(a);
    });
  }),

  setupRentalAutocomplete(),
  
  document
    .getElementById("btnRentalSearch")
    ?.addEventListener("click", handleRentalSearch),

  document
    .getElementById("btnRentalReset")
    ?.addEventListener("click", handleRentalReset),
  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll("#AirportFromInput, #AirportToInput")
      .forEach((a) => {
        a.addEventListener("keypress", (a) => {
          if ("Enter" === a.key) {
            a.preventDefault();
            const e = document.getElementById("AirportFromInput").value.trim(),
              t = document.getElementById("AirportToInput").value.trim();
            e && t && handleAirportSearch();
          }
        });
      });
  }),

  (document.getElementById("AirportToInput").disabled = !1),

  document.querySelector(".airport-arrow")?.addEventListener("click", () => {
    const a = document.getElementById("AirportFromInput"),
      e = document.getElementById("AirportToInput");
    [a.value, e.value] = [e.value.trim(), a.value.trim()];
  }),

  document
    .getElementById("btnAirportSearch")
    ?.addEventListener("click", handleAirportSearch),

  document
    .getElementById("btnAirportReset")
    ?.addEventListener("click", handleAirportReset),

  document.querySelectorAll('#tab-airport input[type="text"]').forEach((a) => {
    a.addEventListener("keypress", (a) => {
      "Enter" === a.key && handleAirportSearch(a);
    });
  }),

  window.addEventListener("popstate", function (a) {
    const e = a.state || { view: "baseline" },
      t = document.querySelector(".tab-pane.active")?.id;
    if ("baseline" === e.view || !e.view)
      return "tab-airport" === t
        ? handleAirportReset()
        : "tab-shinkansen" === t
          ? handleShinkansenReset()
          : "tab-rental" === t
            ? handleRentalReset()
            : void 0;
  }),

  document.addEventListener("DOMContentLoaded", async function () {
    const a = await fetchAllMeta();
    stationRoutes = {};
    for (const e of a) {
      const a = Array.isArray(e.departure)
          ? e.departure
          : e.departure
            ? [e.departure]
            : [],
        t = Array.isArray(e.arrival) ? e.arrival : e.arrival ? [e.arrival] : [];
      for (const e of a)
        if (e) {
          stationRoutes[e] ??= [];
          for (const a of t)
            a && !stationRoutes[e].includes(a) && stationRoutes[e].push(a);
        }
    }
    const e = {};
    Object.entries(stationRoutes).forEach(([a, t]) => {
      t.forEach((t) => {
        (e[t] || (e[t] = []), e[t].includes(a) || e[t].push(a));
      });
    });
    const t = [
      ...new Set([
        ...Object.keys(stationRoutes),
        ...Object.values(stationRoutes).flat(),
      ]),
    ].sort();
    ((window.stationRoutes = stationRoutes),
      (window.stationOptions = t),
      (function () {
        const a = document.getElementById("destination-search"),
          e = document.getElementById("autocomplete-results"),
          t = document.getElementById("selected-keywords");
        (a.addEventListener("focus", () => {
          ((e.style.display = "block"), l());
        }),
          e.addEventListener("change", function (e) {
            if ("checkbox" === e.target.type) {
              const t = e.target.value;
              (e.target.checked && !r.includes(t)
                ? r.push(t)
                : (r = r.filter((a) => a !== t)),
                u(),
                (a.value = ""));
            }
          }),
          t.addEventListener("change", function (a) {
            if ("checkbox" === a.target.type) {
              const e = a.target.value;
              ((r = r.filter((a) => a !== e)), u(), l());
            }
          }),
          t.addEventListener("click", function (a) {
            if (a.target.classList.contains("remove")) {
              const e = a.target.dataset.key;
              ((r = r.filter((a) => a !== e)), u(), l());
            }
          }));
        const s = document.getElementById("clear-keywords");
        s &&
          s.addEventListener("click", () => {
            ((r = []), u(), l());
          });
        (document.addEventListener("click", function (t) {
          a.contains(t.target) ||
            e.contains(t.target) ||
            (e.style.display = "none");
        }),
          a.addEventListener("input", function () {
            const a = this.value.trim();
            "" === a
              ? l()
              : (function (a) {
                  const e = document.getElementById("autocomplete-results");
                  if (!e) return;
                  const t = e.querySelectorAll(".keyword-group");
                  t.forEach((e) => {
                    const t = e.querySelectorAll(".checkbox-label");
                    let s = 0;
                    t.forEach((e) => {
                      const t = e.innerText
                        .toLowerCase()
                        .includes(a.toLowerCase());
                      ((e.style.display = t ? "" : "none"), t && s++);
                    });
                    const i = s > 0;
                    e.style.display = i ? "" : "none";
                    const o = e.nextElementSibling;
                    o &&
                      "HR" === o.tagName &&
                      (o.style.display = i ? "" : "none");
                  });
                })(a);
          }),
          l());
      })());
    document.getElementById("tab-extra-content");
    const s = document.querySelectorAll(".tab-menu .tab"),
      i = document.querySelectorAll(".tab-pane"),
      o = document.getElementById("main-tab-banner");
    rentalProducts.length > 0 &&
      rentalProducts
        .map((a) => {
          rentalCarList[0].passes.find((e) => e.title === a.title);
        })
        .join("");

    function n(a) {
      a && a.preventDefault();
      const e = document.getElementById("destination-search");
      let t = (e?.value || "").trim();
      if (!t) {
        const a = document.getElementById("selected-keywords");
        if (a) {
          ((t = Array.from(a.querySelectorAll(".keyword-chip"))
            .map((a) => {
              const e = a.cloneNode(!0);
              return (
                e.querySelector(".remove")?.remove(),
                e.textContent.trim()
              );
            })
            .filter(Boolean)
            .join(", ")),
            console.log("🔎 Chip keywords captured:", t));
        }
      }
      if (!t) {
        // JIKA INPUT KOSONG → REDIRECT KE EXPLORE
        window.location.href = "https://japantrips.id/pages/explore-japantrips";
        return;
      }
      const s = Array.from(
          document.querySelectorAll("#selected-keywords .remove"),
        )
          .map((a) => a.getAttribute("data-key"))
          .filter(Boolean),
        i = new URLSearchParams({ q: t, type: "railpass" });
      if (s.length) {
        const a = s.map((a) => (a.includes("::") ? a.split("::")[1] : a));
        i.set("keywords", a.join(","));
      }
      const o = `/pages/explore-japantrips?${i.toString()}`;
      (console.log("✅ Redirecting ke:", o), window.location.assign(o));
    }

    (parseAirportVariants(),
      setupLinkedAutocomplete(
        "fromStationInput",
        "toStationInput",
        stationRoutes,
      ),
      setupLinkedAutocomplete(
        "fromRentalInput",
        "toRentalInput",
        carRentalRoutes,
      ),
      setupLinkedAutocomplete(
        "AirportFromInput",
        "AirportToInput",
        airportRoutes,
      ),
      document
        .getElementById("clear-keywords")
        ?.addEventListener("click", function () {
          const a = document.getElementById("tab-extra-content");
          renderRailpassExtraContent("all", railPasses);
          const e = a.querySelector(".search-result-heading");
          (e && e.remove(),
            (r = []),
            u(),
            document
              .querySelectorAll('#autocomplete-results input[type="checkbox"]')
              .forEach((a) => {
                a.checked = !1;
              }));
          const t = document.getElementById("destination-search");
          t && (t.value = "");
        }));
    Array.from(
      new Set(
        railPasses.flatMap((a) => a.passes).flatMap((a) => a.keywords || []),
      ),
    ).filter(Boolean);
    let r = [];
    function u() {
      const a = document.getElementById("selected-keywords"),
        e = document.getElementById("destination-search");
      a &&
        e &&
        ((a.innerHTML = r
          .map(
            (a) =>
              `\n      <span class="keyword-chip">\n        ${a.includes("::") ? a.split("::")[1] : a}\n        <span class="remove" data-key="${a}">×</span>\n      </span>`,
          )
          .join("")),
        a.querySelectorAll(".remove").forEach((a) => {
          a.addEventListener("click", () => {
            const e = a.getAttribute("data-key");
            ((r = r.filter((a) => a !== e)), u());
          });
        }),
        r.length > 0
          ? e.removeAttribute("placeholder")
          : e.setAttribute("placeholder", "Pilih kota tujuan (cth: Tokyo)"));
    }
    function l() {
      const a = document.getElementById("autocomplete-results");
      if (!a) return;
      const e = keywordGroups
        .map(
          (a) =>
            `\n        <div class="keyword-group" data-category="${a.category}">\n          <div class="group-title">${a.label}</div>\n          <div class="group-keywords">\n            ${a.keywords.map((e) => `\n                  <label class="checkbox-label">\n                    <input type="checkbox" value="${a.category}::${e}">\n                    <span>${e}</span>\n                  </label>\n                `).join("")}\n          </div>\n        </div>\n        <hr>\n      `,
        )
        .join("");
      a.innerHTML = e;
      document.querySelectorAll("#autocomplete-results hr").forEach((a) => {
        a.style.display = "";
      });
    }
    const d = document.getElementById("destination-search");
    (d &&
      d.addEventListener("focus", () => {
        const a = document.querySelector(
          '.tab-menu .tab[data-target="#tab-railpass"]',
        );
        a && a.classList.contains("category-button-active") && l();
      }),
      document.querySelectorAll(".tab-item").forEach((a) => {
        a.addEventListener("click", () => {
          (document
            .querySelectorAll(".tab-item")
            .forEach((a) => a.classList.remove("active")),
            document
              .querySelectorAll(".tab-body")
              .forEach((a) => a.classList.add("hidden")),
            a.classList.add("active"));
          const e = a.dataset.tab;
          document.getElementById(`tab-${e}`).classList.remove("hidden");
        });
      }),
      s.forEach((a) => {
        a.addEventListener("click", function () {
          (s.forEach((a) => {
            (a.classList.remove("category-button-active"),
              a.classList.add("category-button-inactive"));
          }),
            this.classList.add("category-button-active"),
            this.classList.remove("category-button-inactive"),
            i.forEach((a) => a.classList.remove("active")));
          const a = document.querySelector(this.getAttribute("data-target"));
          a && a.classList.add("active");
          const e = this.getAttribute("data-banner");
          if (e) {
            const bannerImg = document.getElementById("main-tab-banner-img");
            if (bannerImg) bannerImg.src = e;
            else o && (o.style.backgroundImage = `url('${e}')`);
          }

          this.getAttribute("data-target");
          (i.forEach((a) => a.classList.remove("active")),
            a && a.classList.add("active"));
        });
      }));
    const p = document.querySelector("#tab-shinkansen .shinkansen-card");
    (p && (p.innerHTML = shinkansenTicketContentMap.shinkansen?.content || ""),
      document
        .getElementById("swapDirectionBtn")
        ?.addEventListener("click", () => {
          const a = document.getElementById("fromStationInput"),
            e = document.getElementById("toStationInput");
          (([a.value, e.value] = [e.value, a.value]), updateToOptions(a.value));
        }),
      document.addEventListener("click", (a) => {
        const e = a.target.closest('a.url-product[data-type="airport"]');
        if (!e) return;
        (a.preventDefault(), a.stopPropagation(), a.stopImmediatePropagation());
        const t = (
          e.dataset.route ||
          e.querySelector(".shinkansen-desc")?.textContent ||
          ""
        )
          .split(/↔|→|—|-/)
          .map((a) => a.trim())
          .filter(Boolean);
        if (t.length < 2) return;
        let s = t[0],
          i = t[1];
        const o = document.getElementById("AirportFromInput"),
          n = document.getElementById("AirportToInput");
        if (!o || !n) return;
        ((o.value = s), (n.value = i), (n.disabled = !1));
        const r = document.querySelector(
            'input[name="airport-direction"][value="airportToCity"]',
          ),
          u = document.querySelector(
            'input[name="airport-direction"][value="cityToAirport"]',
          );
        (/airport/i.test(s) && r
          ? (r.checked = !0)
          : /airport/i.test(i) && u && (u.checked = !0),
          handleAirportSearch(),
          document
            .getElementById("tab-extra-content")
            ?.scrollIntoView({ behavior: "smooth", block: "start" }));
      }),
      document.addEventListener("click", (a) => {
        const e = a.target.closest('a.url-product[data-type="shinkansen"]');
        if (!e) return;
        if (a.ctrlKey || a.metaKey || 1 === a.button) return;
        a.preventDefault();
        let t = (e.dataset.from || "").trim(),
          s = (e.dataset.to || "").trim();
        if (!t || !s) {
          const a = (function (a) {
            const e = (a || "").replace(/\s+/g, " ").trim();
            if (!e) return null;
            let t = e.match(/^\s*(.+?)\s*(?:↔|→|←|⇄)\s*(.+?)\s*$/);
            if (t) return { fromLabel: t[1], toLabel: t[2] };
            if (((t = e.match(/^\s*(.+?)\s*(?:—|–|\s-\s)\s*(.+?)\s*$/)), t))
              return { fromLabel: t[1], toLabel: t[2] };
            if (1 === (e.match(/-/g) || []).length) {
              const [a, t] = e.split("-").map((a) => a.trim());
              if (a && t) return { fromLabel: a, toLabel: t };
            }
            return null;
          })(
            (
              e.dataset.route ||
              e.querySelector(".shinkansen-desc")?.textContent ||
              ""
            ).trim(),
          );
          if (!a) return;
          ({ fromLabel: t, toLabel: s } = a);
        }
        const i = document.getElementById("fromStationInput"),
          o = document.getElementById("toStationInput");
        i &&
          o &&
          ((i.disabled = !1),
          (i.readOnly = !1),
          (o.disabled = !1),
          (o.readOnly = !1),
          (i.value = t),
          (o.value = s),
          handleShinkansenSearch(),
          document
            .getElementById("tab-extra-content")
            ?.scrollIntoView({ behavior: "smooth", block: "start" }));
      }),
      document
        .querySelector("#tab-railpass .search-btn1")
        ?.addEventListener("click", n),
      document
        .querySelector("#tab-shinkansen .search-btn2")
        ?.addEventListener("click", handleShinkansenSearch),
      document
        .querySelector("#tab-rental .search-btn2")
        ?.addEventListener("click", handleRentalSearch),
      document
        .querySelectorAll('#tab-railpass input[type="text"]')
        .forEach((a) => {
          a.addEventListener("keypress", (a) => "Enter" === a.key && n(a));
        }),
      document
        .querySelectorAll(
          '#tab-shinkansen input[type="text"], #tab-shinkansen input[type="date"]',
        )
        .forEach((a) => {
          a.addEventListener(
            "keypress",
            (a) => "Enter" === a.key && handleShinkansenSearch(a),
          );
        }),
      document
        .querySelectorAll(
          '#tab-rental input[type="text"], #tab-rental input[type="datetime-local"]',
        )
        .forEach((a) => {
          a.addEventListener(
            "keypress",
            (a) => "Enter" === a.key && handleRentalSearch(a),
          );
        }));
    const c = document.querySelector(
      '.tab-menu .tab[data-target="tab-railpass"]',
    );
    c &&
      (c.classList.add("category-button-active"),
      c.classList.remove("category-button-inactive"));
    const k = document.querySelector("#tab-railpass");
    (k && k.classList.add("active"),
      document.querySelectorAll(".arrow").forEach((a) => {
        (a.addEventListener("click", () => {
          const e = a.closest('[id^="tab-"]');
          if (!e) return;
          const t = e.querySelector("#fromStationInput"),
            s = e.querySelector("#toStationInput");
          t &&
            s &&
            (([t.value, s.value] = [s.value, t.value]),
            updateToOptions(t.value));
        }),
          (a.style.cursor = "pointer"));
      }),
      document
        .getElementById("btnAirportSearch")
        .addEventListener("click", () => {
          const a = document.getElementById("AirportFromInput").value,
            e = document.getElementById("AirportToInput").value,
            t = filterAirportResults(a, e);
          renderAirportResults(t);
        }),
      document
        .querySelectorAll('#tab-railpass input[name="pass-type"]')
        .forEach((a) => {
          a.addEventListener("change", function () {
            const a = this.value;
            (renderRailpassExtraContent(
              a,
              "all" === a ? railPasses : otherPasses,
            ),
              (document.querySelector('#tab-railpass input[name="q"]').value =
                ""),
              (function () {
                const a = document.querySelector(".sidebar-image img");
                document.querySelectorAll(".railpass-detail").forEach((e) => {
                  const t = e.getAttribute("data-sidebar-img");
                  e.addEventListener("mouseenter", () => {
                    t && a && a.src !== t && (a.src = t);
                  });
                });
              })());
            const e = document.getElementById("railpass-nav");
            e && e.scrollIntoView({ behavior: "smooth", block: "start" });
          });
        }),
      document.addEventListener("DOMContentLoaded", function () {
        const a = document.querySelector('a[href="#guide-to-jr-pass"]');
        a &&
          a.addEventListener("click", function (a) {
            a.preventDefault();
            const e = document.querySelector("#guide-to-jr-pass");
            e && e.scrollIntoView({ behavior: "smooth" });
          });
      }),
      document.getElementById("fromStationInput") &&
        document.getElementById("fromStationList") &&
        setupCustomAutocomplete("fromStationInput", "fromStationList", () =>
          Object.keys(stationRoutes),
        ),
      document.getElementById("toStationInput") &&
        document.getElementById("toStationList") &&
        setupCustomAutocomplete("toStationInput", "toStationList", () => {
          const a = document.getElementById("fromStationInput").value,
            t = stationRoutes[a] || [],
            s = e[a] || [];
          return [...new Set([...t, ...s])];
        }),
      document.getElementById("pickupLocationInput") &&
        document.getElementById("pickupLocationList") &&
        setupCustomAutocomplete(
          "pickupLocationInput",
          "pickupLocationList",
          () => Object.keys(carRentalRoutes),
        ),
      document.getElementById("dropoffLocationInput") &&
        document.getElementById("dropoffLocationList") &&
        setupCustomAutocomplete(
          "dropoffLocationInput",
          "dropoffLocationList",
          () => {
            const a = document.getElementById("pickupLocationInput")?.value;
            return carRentalRoutes[a] || e[a] || [];
          },
        ));
  }),

  document.addEventListener("DOMContentLoaded", function () {
    const a = document.getElementById("AirportFromInput"),
      e = document.getElementById("AirportToInput");
    (a &&
      a.addEventListener("keydown", (a) => {
        "Enter" === a.key && handleAirportSearch(a);
      }),
      e &&
        e.addEventListener("keydown", (a) => {
          "Enter" === a.key && handleAirportSearch(a);
        }),
      document
        .getElementById("btnAirportSearch")
        ?.addEventListener("click", handleAirportSearch));
  }),

  document.addEventListener("click", (a) => {
    const e = a.target.closest(".faq-question");
    if (e) {
      e.parentElement.classList.toggle("active");
      const a = "true" === e.getAttribute("aria-expanded");
      e.setAttribute("aria-expanded", String(!a));
    }
  }),

  document.addEventListener("click", (a) => {
    const e = a.target.closest(".faq-questions");
    if (e) {
      e.parentElement.classList.toggle("active");
      const a = "true" === e.getAttribute("aria-expanded");
      e.setAttribute("aria-expanded", String(!a));
    }
  }),

  document.addEventListener("click", function (a) {
    if ("airport-add-to-cart" === a.target.id) {
      const e = a.target.dataset.variant,
        t = parseInt(document.getElementById("airport-qty")?.value || "1", 10);
      if (!e || t <= 0) return;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: e, quantity: t }] }),
      })
        .then(() => {
          (closeAirportModal(), showCartSuccessModal());
        })
        .catch((a) => console.error("Gagal menambah ke keranjang:", a));
    }
  }),

  document.addEventListener("DOMContentLoaded", () => {
    const a = document.getElementById("airport-products-json");
    if (a)
      try {
        window.airportProducts = JSON.parse(a.textContent);
      } catch (a) {
        console.error("❌ Gagal parsing airport JSON:", a);
      }
  }),

  document.addEventListener(
    "focus",
    function (a) {
      "date" === a.target.type &&
        (a.target.showPicker ? a.target.showPicker() : a.target.focus());
    },
    !0,
  ));
